import styled from "styled-components";
import { responsiveMap } from "../../Grid/_utils/responsiveObserve";
import SectionContainer from "../../../Core/SectionContainer/SectionContainer";

export const _LandingVideoSliderAdrienCachotRoot = styled(SectionContainer)`
`;

export const _LandingVideoSliderAdrienCachotTrack = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-padding: 0 max(0px, calc((100% - 1342px) / 2));
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  gap: 16px;
  width: 100%;
  padding: 0 max(0px, calc((100% - 1342px) / 2));

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${responsiveMap.mobile} {
    gap: 8px;
    padding: 0 32px;
    scroll-padding: 0 32px;
  }
`;

export const _LandingVideoSliderAdrienCachotTrackItem = styled.div`
  flex: 0 0 100%;
  max-width: 1342px;
  scroll-snap-align: center;
`;

export const _LandingVideoSliderAdrienCachotDotsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
`;

export const _LandingVideoSliderAdrienCachotDot = styled.button<{
  $active: boolean;
}>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: none;
  padding: 0;
  cursor: pointer;
  background: ${({ $active }) => ($active ? "#fff" : "rgba(255,255,255,0.3)")};
  transition: background 0.25s;
`;

export const _LandingVideoSliderAdrienCachotArrow = styled.button<{
  $side: "left" | "right";
}>`
  position: absolute;
  top: 0;
  ${({ $side }) => $side}: 0;
  width: 72px;
  height: 100%;
  z-index: 10;
  border: none;
  padding: 0;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
`;
